import { usePage } from '@inertiajs/react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

const validUrl = (v) => typeof v === 'string' && /^(https?:\/\/|\/)/.test(v);

export function BrandMark({ collapsed = false, className, withName = true, size = 'md' }) {
    const { branding, app } = usePage().props;
    const iconUrl = validUrl(branding?.logo_icon) ? branding.logo_icon
        : validUrl(branding?.site_logo) ? branding.site_logo
        : null;
    const name = branding?.site_name || app?.name || 'KodMail';

    const flag = branding?.logo_variant === 'full_image' ? 'full_image' : 'icon_text';
    const fullImage = validUrl(branding?.logo_image) ? branding.logo_image
        : (flag === 'full_image' && iconUrl) ? iconUrl
        : null;
    const variant = fullImage ? 'full_image' : flag;

    const tileSize = size === 'sm' ? 'size-7' : size === 'lg' ? 'size-10' : 'size-8';
    const tileInner = size === 'sm' ? 'size-4' : size === 'lg' ? 'size-6' : 'size-5';
    const wordmarkClass = size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-lg' : 'text-[15px]';

    // Custom asset uses bare icon - accent tile is platform default only.
    const renderIconTile = () => {
        if (iconUrl) {
            return (
                <div className={cn('grid shrink-0 place-items-center overflow-hidden', tileSize)}>
                    <img src={iconUrl} alt="" className="size-full object-contain" />
                </div>
            );
        }
        return (
            <div className={cn(
                'grid shrink-0 place-items-center overflow-hidden rounded-md bg-primary text-primary-foreground shadow-sm',
                tileSize,
            )}>
                <Sparkles className={cn(tileInner)} strokeWidth={1.75} />
            </div>
        );
    };

    if (variant === 'full_image' && fullImage && ! collapsed) {
        return (
            <div className={cn('flex items-center min-w-0', className)} title={name}>
                <img
                    src={fullImage}
                    alt={name}
                    className={cn(
                        'block max-h-9 w-auto max-w-[170px] object-contain',
                        size === 'sm' && 'max-h-7',
                        size === 'lg' && 'max-h-10',
                    )}
                />
            </div>
        );
    }

    if (variant === 'full_image' && collapsed) {
        return (
            <div className={cn('flex items-center', className)} title={name}>
                {renderIconTile()}
            </div>
        );
    }

    return (
        <div className={cn('flex items-center gap-1.5 min-w-0', className)} title={name}>
            {renderIconTile()}
            {withName && ! collapsed && (
                <span className={cn('truncate font-semibold tracking-tight', wordmarkClass)}>
                    {name}
                </span>
            )}
        </div>
    );
}
